import { TypeAsnDocument } from '../../interfaces/Asn/TypeAsnDocument'
import { TypeAsnDocumentAction } from '../actions/typeAsnDocumentActions'
import { GET_TYPE_ASN_DOCUMENT_EXITO } from '../types/typeAsnDocumentActionsTypes'

export interface TypeAsnDocumentState {
  typeAsnDocumentState: {
    typeAsnDocument?: TypeAsnDocument[]
    error?: string | undefined
  }
}

const initialState: TypeAsnDocumentState = {
  typeAsnDocumentState: { typeAsnDocument: [], error: '' }
}

export const typeAsnDocumentReducer = (
  state: TypeAsnDocumentState = initialState,
  action: TypeAsnDocumentAction
): TypeAsnDocumentState => {
  if (action.type === GET_TYPE_ASN_DOCUMENT_EXITO) {
    return {
      ...state,
      typeAsnDocumentState: {
        typeAsnDocument: action.typeAsnDocument,
        error: action.error
      }
    }
  }
  return state
}
